import { Grid, Typography } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import styles from "../../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import { getWhatsappMediaAllowedFileTypes, getWhatsappMediaSizeLimit } from "../../../../../../utils/constants";

import Required from "../../../../../utility/required";
import FileUpload from "../../../../../utility/fileUpload/fileUpload";
import { useTemplateLibraryStore } from "../../../../../../store/templateLibraryStore";
import { ALLOWED_MEDIA_HEADER_TYPES_CAROUSEL } from "../../../constant";
import { useShallow } from "zustand/react/shallow";
import { useCarouselFunctions } from "../../../utils/useCarouselFunctions";
import TouchTooltip from "../../../utils/TouchTooltip";

const CarouselFormCardHeader = (props: any) => {

    const { cardData, cardIndex, carouselFiles, uploadFileHandlerCarousel, removeFileHandlerCarousel, isFileUploaded } = props;

    const { isMobileScreen } = useCarouselFunctions();

    const { createTemplatePayload } = useTemplateLibraryStore(useShallow((state) => ({
        createTemplatePayload: state.createTemplatePayload,
    })));

    const cardUploadedFiles = carouselFiles?.find((f: any) => f.index === cardIndex)?.carousels ?? [];

    return (
        <>
            {ALLOWED_MEDIA_HEADER_TYPES_CAROUSEL?.includes(cardData?.whatsapp_template_header?.whatsapp_template_header_type_name?.toLowerCase() || "") &&
                <Grid item xs={12}>
                    <Grid container>

                        <Grid item xs={12}>
                            <Typography component={'span'} className={styles.templateHeadtext}>
                                {`Upload Header ${cardData?.whatsapp_template_header?.whatsapp_template_header_type_name}`}
                            </Typography>

                            <Required />

                            <TouchTooltip
                                key="upload-header-tooltip"
                                title={
                                    <span>
                                        Allowed Formats: {getWhatsappMediaAllowedFileTypes(cardData?.whatsapp_template_header?.whatsapp_template_header_type_name || "")?.displayTypeToUser}
                                    </span>
                                }
                                placement={isMobileScreen ? 'top-start' : 'right'}
                            >
                                <InfoOutlinedIcon className={styles.infoIcon} />
                            </TouchTooltip>
                        </Grid>

                        <Grid item xs={12} sx={{ margin: '5px 0px 0px' }}>
                            <FileUpload
                                uploadedFileDetails={cardUploadedFiles}
                                multipleFileAllow={false}
                                // fileSizeAllowed={selectedHeaderType.whatsapp_template_header_type_name.toLowerCase() === "image" ? 3 : selectedHeaderType.whatsapp_template_header_type_name.toLowerCase() === "video" ? 16 : 2} 
                                fileSizeAllowed={getWhatsappMediaSizeLimit(cardData?.whatsapp_template_header?.whatsapp_template_header_type_name || "")}
                                // fileTypeAllowed={headerFileTypes(selectedHeaderType.whatsapp_template_header_type_name)}
                                fileTypeAllowed={getWhatsappMediaAllowedFileTypes(cardData?.whatsapp_template_header?.whatsapp_template_header_type_name || "")?.allowedType}
                                fileNumberAllowed={1}
                                isDisabled={createTemplatePayload?.whatsapp_template_id ? true : false}
                                uploadFileHandler={(e) => uploadFileHandlerCarousel(e, cardIndex)}
                                removeFileHandler={(storage_id: number) => removeFileHandlerCarousel(storage_id, cardIndex)}
                                isDeleteFileIconVisible={isFileUploaded}
                                bgColor='#ffffff'
                                flagWhatsapp={true}
                            />
                        </Grid>

                    </Grid>
                </Grid>
            }
        </>
    )
}

export default CarouselFormCardHeader;